export type PaginationInput = {
  pageSize: number;
  pageNumber: number;
  sortDirection?: SortDirection;
  sortField?: string;
};

export type PaginationQueryObject = {
  pageSize?: number;
  pageNumber?: number;
  sortField?: string;
  sortDirection?: SortDirection;
  totalPages?: number;
  totalElements?: number;
  hasNext?: boolean;
  hasPrevious?: boolean;
};

export type QueryConfig = {
  query: string;
  variables: any;
};

export type QueryRequest<T> = {
  query: string;
  variables?: T;
};

export type QuerySort = {
  sortDirection: SortDirection;
  sortField: string;
} | null;

export enum SortDirection {
  ASC = "ASC",
  DESC = "DESC",
}

export const getPagination = (
  page: number,
  pageSize: number,
  querySort: QuerySort
): PaginationQueryObject => {
  const paginationInput: PaginationQueryObject = {
    pageSize: Number(pageSize),
    pageNumber: Number(page) || 1,
  };
  if (querySort) {
    paginationInput.sortField = querySort.sortField;
    paginationInput.sortDirection = querySort.sortDirection;
  }

  return paginationInput;
};

export type BaseFilter<T> = {
  and?: T;
  not?: T;
  or?: T;
};

export const defaultPagination = {
  first: 0,
  page: 0,
};
